var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecryptSecurityDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CBD0DC",
    d: "M22.47 6.73c-.03-.63-.03-1.22-.03-1.82a.837.837 0 00-.82-.85h-.03c-3.55 0-6.25-1.02-8.5-3.21a.878.878 0 00-1.19 0C9.66 3.04 6.96 4.06 3.4 4.06c-.46 0-.84.36-.85.83v.03c0 .6 0 1.19-.03 1.82-.11 5.97-.28 14.15 9.69 17.59l.28.06.28-.06c9.96-3.44 9.82-11.6 9.7-17.6zM11.82 15c-.17.14-.38.23-.6.23h-.03c-.23 0-.45-.11-.6-.28l-2.64-2.93 1.28-1.14 2.07 2.3 4.6-4.38 1.17 1.25L11.82 15z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecryptSecurityDisabled);
export default __webpack_public_path__ + "static/media/recrypt_security_disabled.20e82fa0.svg";
export { ForwardRef as ReactComponent };